/**
 * 专利管理 检索任务
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>检索任务</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- 搜索筛选 -->
    <!-- <dv-border-box-9> -->
    <div class="search-top">
        <div style="margin: 10px 10px;font-size: 14px;color: #606266;">
            模块说明：可以设置检索字段和检索字段值，系统会根据检索字段值每天不断的查询专利信息，将未监控的专利自动监控(目前只支持申请人)
        </div>
    </div>
    <div class="search-top">
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="检索值:" style="margin-left: 15px;">
                <el-input size="small" v-model="formInline.searchValue" placeholder="输入检索值" clearable></el-input>
            </el-form-item>
            <el-form-item style="margin-left: 15px;">
                <el-button size="small" type="primary" @click="search">查询</el-button>
                <el-button size="small" type="primary" @click="handleAdd">添加</el-button>
                <el-button size="small" type="primary" @click="handleImport" title="批量监控勾选的专利">导入</el-button>
                <el-button size="small" type="danger" @click="deleteCheckValue">删除</el-button>
            </el-form-item>
        </el-form>
    </div>
    <!-- </dv-border-box-9> -->
    

    <!-- <div style="display: flex;"> -->
      <!-- <div style="width: auto;"> -->
        <!-- 右侧数据显示列表 -->
        <!--列表-->
        <el-table size="small" @selection-change="handleSelectionChange" :data="userData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
          <el-table-column align="center" type="selection" width="50">
          </el-table-column>
          <el-table-column align="center" type="index" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="id" v-if="idShow">
          </el-table-column>
          <el-table-column align="center" prop="field_desc" label="检索字段">
          </el-table-column>
          <el-table-column align="center" prop="value" label="检索字段值">
          </el-table-column>
          <el-table-column align="center" label="操作" min-width="120">
            <template slot-scope="scope">
              <el-button size="mini" type="danger" @click="deleteValue(scope.$index, scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      <!-- </div> -->
    <!-- </div> -->

    <!-- 详情界面 -->
    <el-dialog :title="title" :visible.sync="infoFormVisible" width="60%" @click='closeDialog("info")'>
      <el-form label-width="80px" ref="infoForm" :model="infoForm" :rules="rules">
        <el-row>
          <el-col :span="8">
            <el-form-item label="专利名称" prop="zlmc">
              <el-input size="small" v-model="infoForm.zlmc" auto-complete="off" placeholder="专利名称" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请人" prop="applicant">
              <el-input size="small" v-model="infoForm.applicant" auto-complete="off" placeholder="申请人" disabled></el-input>
            </el-form-item>
            <el-form-item label="发明人" prop="inventor">
              <el-input size="small" v-model="infoForm.inventor" auto-complete="off" placeholder="发明人" disabled></el-input>
            </el-form-item>
            <el-form-item label="当前权人" prop="current_assignee">
              <el-input size="small" v-model="infoForm.current_assignee" auto-complete="off" placeholder="当前权人" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请日" prop="apply_date">
              <el-input size="small" v-model="infoForm.apply_date" auto-complete="off" placeholder="申请日" disabled></el-input>
            </el-form-item>
            <el-form-item label="待缴类目" prop="category">
              <el-input size="small" v-model="infoForm.category" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请地址" prop="applicant_address">
              <el-input size="small" v-model="infoForm.applicant_address" auto-complete="off" placeholder="申请地址" disabled></el-input>
            </el-form-item>
          </el-col>
         <el-col :span="8">
           <el-form-item label="专利号" prop="zlid_code">
              <el-input size="small" v-model="infoForm.zlid_code" auto-complete="off" placeholder="专利号" disabled></el-input>
            </el-form-item>
            <el-form-item label="公开号" prop="zlwyid">
              <el-input size="small" v-model="infoForm.zlwyid" auto-complete="off" placeholder="公开公告号" disabled></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="current_status">
              <el-input size="small" v-model="infoForm.current_status" auto-complete="off" placeholder="状态" disabled></el-input>
            </el-form-item>
             <el-form-item label="代理人" prop="agent">
              <el-input size="small" v-model="infoForm.agent" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
            <el-form-item label="公开日" prop="document_date">
              <el-input size="small" v-model="infoForm.document_date" auto-complete="off" placeholder="公开日" disabled></el-input>
            </el-form-item>
            <el-form-item label="待缴金额" prop="money">
              <el-input size="small" v-model="infoForm.money" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
         </el-col>
         <el-col :span="8">
           <el-form-item label="专利类型" prop="zllx">
              <el-input size="small" v-model="infoForm.zllx" auto-complete="off" placeholder="专利类型" disabled></el-input>
            </el-form-item>
            <el-form-item label="申请类型" prop="applicant_type">
              <el-input size="small" v-model="infoForm.applicant_type" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
            <el-form-item label="主分类号" prop="main_ipc">
              <el-input size="small" v-model="infoForm.main_ipc" auto-complete="off" placeholder="IPC主分类号" disabled></el-input>
            </el-form-item>
            <el-form-item label="代理机构" prop="agency">
              <el-input size="small" v-model="infoForm.agency" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
            <el-form-item label="IPC" prop="ipc">
              <el-input size="small" v-model="infoForm.ipc" auto-complete="off" placeholder="IPC" disabled></el-input>
            </el-form-item>
            <el-form-item label="截止日期" prop="date_time">
              <el-input size="small" v-model="infoForm.date_time" auto-complete="off" placeholder="暂无" disabled></el-input>
            </el-form-item>
         </el-col>
        </el-row>
        <el-form-item>
        <el-button @click="submitInfoForm()" style="float: right;">确定</el-button>
      </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 添加界面 -->
    <el-dialog :title="title" :visible.sync="addFormVisible" width="40%" @click='closeDialog("add")'>
      <el-form label-width="80px" ref="addForm" :model="addForm" :rules="addRules">
        <el-form-item label="检索值" prop="value">
            <el-input size="small" v-model="addForm.value" auto-complete="off" placeholder="请输入检索值"></el-input>
        </el-form-item>
        <el-form-item>
        <el-button size="small" type="primary" @click="submitAddForm('addForm')">确定</el-button>
        <el-button size="small" @click="closeAddForm()">取消</el-button>
      </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 导入界面 -->
    <el-dialog :title="title" :visible.sync="importFormVisible" width="40%" @click='closeDialog("import")'>
      <el-form label-width="120px">
          <el-row>
            <el-form-item label="上传表格" prop="content">
                <el-upload
                  class="upload-demo"
                  drag
                  :action=uploadExcel
                  :headers=setHeader
                  :before-upload="beforeAvatarVideoUpload"
                  :before-remove="beforeRemove"
                  :on-remove="handleRemove"
                  :on-success="handleSuccess"
                  multiple>
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M
                      <!-- <button @click="downloadExcel()" style="margin-left: 15px;cursor: pointer">下载模板</button> -->
                  </div>
                </el-upload>
                </el-form-item>
          </el-row>
        </el-form>
    </el-dialog>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
// 导入请求方法
import {
  searchValueList,
  webUrl,
  addSearchValue,
  delSearchValue,
  delCheckSearchValue,
  exportCheck,
  exportAll
} from '../../api/patentMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      idShow: false, //列表uid不显示
      infoFormVisible: false, //详情界面是否显示
      addFormVisible: false, //添加界面是否显示
      importFormVisible: false, //导入界面是否显示
      title: '',
      multipleSelection: [],
      pickerOptions: {
          shortcuts: [{
            text: '今天',
            onClick(picker) {
              picker.$emit('pick', new Date());
            }
          },{
            text: '昨天',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit('pick', date);
            }
          },{
            text: '一周前',
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', date);
            }
          }]
          },
      // 选择数据
      selectdata: [],
      // rules表单验证
      rules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        real_name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        role_id: [{ required: true, message: '请选择角色', trigger: 'blur' }],
        mobile: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' },
          {
            pattern: /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/,
            required: true,
            message: '请输入正确的邮箱',
            trigger: 'blur'
          }
        ],
        sex: [{ required: true, message: '请选择性别', trigger: 'blur' }]
      },
      addRules: {
          value: [
          { required: true, message: '请输入检索值', trigger: 'blur' }
        ],
      },
      // 请求数据参数
      formInline: {
        page: 1,
        ps: 10,
        searchValue: ''
      },
      setHeader:{
        'token': localStorage.getItem('logintoken')
      },
      uploadExcel: webUrl + '/patent/search/importSearchValue',
      infoForm: [],
      addForm: {
        value: ''
      },
      //用户数据
      userData: [],
      // 数据权限
      UserDept: [],
      // 选中
      checkmenu: [],
      //参数role
      saveroleId: '',
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },

  /**
   * 数据发生改变
   */
  watch: {},

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

      // 视频上传oss 开始
    // 文件超出个数限制时的钩子
    handleExceed(files, fileList) {
      this.$message.warning(`每次只能上传 ${this.limit} 个文件`);
    },
    // 点击文件列表中已上传的文件时的钩子
    handlePreview(file) {},
    // 删除文件之前的钩子
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`);
    },
    // 文件列表移除文件时的钩子
    handleRemove(file, fileList) {},
    // 文件上传成功时的钩子
    handleSuccess(response, file, fileList) {
      if(response.code == 200){
          this.$message({
              type: 'success',
              message: response.msg
          })
          this.importFormVisible = false
          this.getdata(this.formInline)
      }else{
          this.$message({
              type: 'error',
              message: response.msg
          })
      }
    },
    //文件上传前的校验
    beforeAvatarVideoUpload(file) {
      const that = this
       if (!/\.(xlsx|xls|XLSX|XLS)$/.test(file.name)) {
          that.$message({
              type: 'error',
              message: '上传文件只能为excel文件，且为xlsx,xls格式!'
          })
          return false
        }

    // 请求后台接口拿配置参数
      return new Promise((resolve, reject) => {
          const configData = {
              region:'oss-cn-qingdao',
              accessKeyId:'LTAI4FuLvbyHn9zoeQgqd5hG',
              accessKeySecret:'23U5LuP39m4TJz8a0snWcOs7Yxq85b',
              bucket:'qzhi2019-oss',
          }
          this.dataObj = configData
          resolve(true)
      });
    },
    // http-request属性来覆盖默认的上传行为（即action="url"），自定义上传的实现 
    Upload(file) {
      console.log(file)
      // 前缀
      // let videoPrefix = 'http://qzhi2019-oss.oss-cn-qingdao.aliyuncs.com/'
      const that = this;
      async function multipartUpload() {
        // let temporary = file.file.name.lastIndexOf(".");
        // let fileName = file.file.name;

        // Excel上传服务器
        that.$axios({
        url: webUrl+'/admin/monitor/importPatMonitor',
        data: file,
        method: 'POST',
        headers: { 
          // "Content-Type": "multipart/form-data",
          "token": localStorage.getItem('logintoken')
          },
      })
        .then(result =>{
          console.log(result)
        })
        .catch(err => {
          console.log("err:", err);
        });
      }
      multipartUpload();
    },
    // 视频上传oss 结束

    // 获取数据方法
    getdata(parameter) {
       this.loading = true
       /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       searchValueList(parameter)
       .then(res=>{
          this.loading = false
          console.log(res);
          res = checkLogin(res);
          if (res.code == 200) {
            this.userData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
       })
       .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    //搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    // 显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.title = '专利信息详情'
      this.infoForm = row
      this.infoFormVisible = true
    },
    // 显示添加检索值
    handleAdd() {
        this.title = '添加检索值'
        this.addForm.value = ''
        this.addFormVisible = true
    },
    // 显示导入检索值
    handleImport(){
        this.importFormVisible = true
    },
    // 删除勾选检索值
    delCheck(){

    },
    // 删除专利(单个)
    deleteValue(index, row){
      console.log(row)
      this.$confirm('确定确定删除该数据吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
    }).then(()=>{
       delSearchValue({id:row.id})
          .then(res => {
            res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
          })

    }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 删除专利(勾选)
    deleteCheckValue(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定删除勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        delCheckSearchValue(exportParam)
            .then(res => {
              res = checkLogin(res)
            if (res.code == 200) {
              this.$message({
                type: 'success',
                message: res.msg
              })
            this.getdata(this.formInline)
            } else {
              this.$message({
                type: 'info',
                message: res.msg
              })
            }
        })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    submitInfoForm(){
      this.infoFormVisible = false
    },
    // 确认添加检索值
    submitAddForm(addForm){
        this.$refs[addForm].validate(valid => {
            if(valid){
                addSearchValue({value:this.addForm.value})
                .then(res=>{
                    if(res.code == 200){
                        this.$message({
                            type: 'success',
                            message: res.msg
                        })
                        this.addFormVisible = false
                        this.getdata(this.formInline)
                    }else{
                        this.$message({
                            type: 'error',
                            message: res.msg
                        })
                    }
                })
                .catch(res=>{
                        this.$message({
                            type: 'error',
                            message: '系统错误!'
                        })
                })
            }else{
                return false
            }
        })
    },
    closeAddForm(){
        this.addFormVisible = false
    },
    // 导出勾选中的数据
    exportCheck(){
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
          this.$message({
            type: 'info',
            message: '未勾选任何记录'
        })
        return false;
      }
      this.$confirm('确定导出勾选的数据吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
    .then(() => {
      const idStr = JSON.stringify(idsArr)
      const exportParam = {ids:idStr}
        exportCheck(exportParam)
                .then(res => {
                  res = checkLogin(res)
                  if (res.code == 200) {
                    location.href = res.data.url
                    this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                  } else {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  }
                })
      })
      .catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    // 导出满足条件的数据
    exportAll(){
      this.$confirm('确定导出所有满足条件的数据吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
      })
      .then(() => {
          if(this.formInline.sqrq_start_time == null){
              this.formInline.sqrq_start_time = ''
          }
          if(this.formInline.sqrq_end_time == null){
              this.formInline.sqrq_end_time = ''
          }
          if(this.formInline.sqrq_date == null){
              this.formInline.sqrq_date = ''
          }
          if(this.formInline.gkr_start_time == null){
              this.formInline.gkr_start_time = ''
          }
          if(this.formInline.gkr_end_time == null){
              this.formInline.gkr_end_time = ''
          }
          if(this.formInline.gkr_date == null){
              this.formInline.gkr_date = ''
          }
            exportAll(this.formInline)
              .then(res => {
                if (res.code == 200) {
                  location.href = res.data.url
                  this.$message({
                      type: 'success',
                      message: '导出成功!'
                    })
                } else {
                  this.$message({
                    type: 'info',
                    message: res.msg
                  })
                }
              })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(dialog) {
      if (dialog == 'edit') {
        this.editFormVisible = false
      } else if (dialog == 'info') {
        this.infoFormVisible = false
      }
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.left-filter-top {
  font-size: 14px;
  margin: 10px 0;
  width: 180px;
  border-bottom: 1px solid #EBEEF5;
}
.search-top {
  border: 1px solid #EBEEF5;
  margin: 10px 0;
  border-radius: 5px;

}
.el-form-item {
    margin-bottom: 10px;
}
</style>

 


// WEBPACK FOOTER //
// src/views/patent/task.vue